if (!customElements.get('text-column-slider-controller')) {
  class TextColumnSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperInstance = null;
      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange();
    }

    disconnectedCallback() {
      this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
      this.destroySwiper();
    }

    handleBreakpointChange() {
      if (this.desktopQuery.matches) {
        this.destroySwiper();
      } else {
        this.initSwiper();
      }
    }

    initSwiper() {
      const swiperContainer = this.querySelector(`#text-column-slider-${this.dataset.id}`);

      if (this.swiperInstance || !swiperContainer || typeof Swiper === 'undefined') {
        return;
      }

      this.swiperInstance = new Swiper(swiperContainer, {
        speed: DEFAULT_SLIDER_SPEED,
        slidesPerView: 1.3,
        spaceBetween: Number(this.dataset.spaceBetween) || 0,
      });
    }

    destroySwiper() {
      if (!this.swiperInstance) {
        return;
      }

      if (!this.swiperInstance.destroyed) {
        this.swiperInstance.destroy(true, true);
      }

      this.swiperInstance = null;
    }
  }

  customElements.define('text-column-slider-controller', TextColumnSlider);
}
